function memo(fn) {
  const cache = /* @__PURE__ */ new Map();
  return function cached(...args) {
    const key = args.join("");
    if (!cache.has(key)) {
      cache.set(key, fn(...args));
    }
    return cache.get(key);
  };
}
export {
  memo
};
//# sourceMappingURL=memo.js.map
